import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ELIGIBILITY_API = "https://be.corebankers.in/wa-msg91/wa-eligibility";
const PROFILE_API = "https://be.corebankers.in/wa-msg91/wa-profile";
const MSG91_TOKEN = "1EA7B5179FCF5F583A6AA795269C4";

const formatMobileNumber = (num) => `91${num.replace(/\D/g, "").slice(-10)}`;
const isValidMobile = (num) => /^[6-9]\d{9}$/.test(num.replace(/\D/g, ""));
const isValidPAN = (pan) => /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan.toUpperCase());

export default function EligibilityForm() {
  const [step, setStep] = useState(1);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [pan, setPan] = useState("");
  const [company, setCompany] = useState("");
  const [monthlyIncome, setMonthlyIncome] = useState("");
  const [existingEmis, setExistingEmis] = useState("");
  const [requiredLoan, setRequiredLoan] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const handleNext = () => {
    if (!name || !mobile || !pan) {
      setError("Please fill all fields.");
      return;
    }
    if (!isValidMobile(mobile)) {
      setError("Invalid mobile number. Check once.");
      return;
    }
    if (!isValidPAN(pan)) {
      setError("Invalid PAN number. Check once.");
      return;
    }
    setError(null);
    setStep(2);
  };

  const handleSubmitDetails = async () => {
    const payload = {
      contacts: [{ wa_id: formatMobileNumber(mobile), profile: { name } }],
      message: {
        details: {
          fullName: name,
          panNumber: pan.toUpperCase(),
          companyName: company,
          monthlyIncome,
          existingEmis,
          requiredLoan,
        },
      },
      source: "Web-Eli",
    };

    await axios.post(PROFILE_API, payload, {
      headers: {
        Authorization: `Bearer ${MSG91_TOKEN}`,
        "Content-Type": "application/json",
      },
    });
  };

  const handleCheckEligibility = async () => {
    if (!company || !monthlyIncome || !requiredLoan) {
      setError("Please fill all fields.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // 🧠 Store financial inputs locally
      localStorage.setItem("userFinancials", JSON.stringify({
        monthlyIncome,
        existingEmis,
        requiredLoan
      }));

      await handleSubmitDetails();

      const response = await axios.post(
        ELIGIBILITY_API,
        { phone: formatMobileNumber(mobile) },
        {
          headers: {
            Authorization: `Bearer ${MSG91_TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );

      const sortedBanks = (response.data.banks || []).sort(
        (a, b) => parseFloat(a.estimatedRate) - parseFloat(b.estimatedRate)
      );

      // Store eligibility result locally
      localStorage.setItem("eligibilityResult", JSON.stringify({
        ...response.data,
        banks: sortedBanks
      }));

      navigate("/results", {
        state: {
          result: { ...response.data, banks: sortedBanks },
        },
      });
    } catch {
      setError("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {step === 1 && (
        <>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Name (As per PAN)"
          />
          <input
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="Mobile Number"
          />
          <input
            value={pan}
            onChange={(e) => setPan(e.target.value)}
            style={{ textTransform: "uppercase" }}
            placeholder="PAN Number"
          />
          <button onClick={handleNext}>Next</button>
        </>
      )}

      {step === 2 && (
        <>
          <input
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            placeholder="Current Company Name"
          />
          <input
            type="number"
            value={monthlyIncome}
            onChange={(e) => setMonthlyIncome(e.target.value)}
            placeholder="Monthly Income (₹)"
          />
          <input
            type="number"
            value={existingEmis}
            onChange={(e) => setExistingEmis(e.target.value)}
            placeholder="Existing EMIs (₹)"
          />
          <input
            type="number"
            value={requiredLoan}
            onChange={(e) => setRequiredLoan(e.target.value)}
            placeholder="Required Loan Amount (₹)"
          />
          <button onClick={handleCheckEligibility} disabled={loading}>
            {loading ? "Checking..." : "Get Estimates"}
          </button>
        </>
      )}

      {error && <p className="form-error">{error}</p>}
    </div>
  );
}